import UploaderFile from './uploader-file.js';

const sortFilesAscending = (
  filesToSort: Array<UploaderFile> = []
): Array<UploaderFile> =>
  filesToSort.sort((file1: UploaderFile, file2: UploaderFile) => {
    const file1Name = file1.name.toLocaleLowerCase();
    const file2Name = file2.name.toLocaleLowerCase();

    if (file1Name < file2Name) {
      return -1;
    }
    if (file2Name > file1Name) {
      return 1;
    }

    return 0;
  });

export default sortFilesAscending;
